import React from "react";
import {
  convertStraight,
  convertThenFormat,
  convertTo12HourFormat,
  formatDateTime,
} from "../common-data/Converts";
import PartialDetails from "../upgrade-membership/PartialDetails";
// import { CheckCircleIcon, XCircleIcon } from "../../images/icons/icons";

const ViewDetails = ({ rowData, isDP }) => {
  const isPT = rowData?.type === "addon_pt";
  const isDual = rowData?.payment_mode === "cash/online";
  const isPartial = rowData?.payment_mode === "partial";
  const isPending = rowData?.status === "pending";

  return (
    <>
      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Member info</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.user_name || "NA"}
                <br />
                <small
                  style={{
                    textTransform: "lowercase",
                    textDecoration: "underline",
                  }}
                >
                  {rowData?.user_mobile || ""}
                  <br />
                  {rowData?.user_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">gender</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.user_gender || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">gym name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.gym_name || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Lead Source</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.lead_source?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">created by</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.created_by_name || "NA"}
                <br />
                <small
                  style={{
                    textTransform: "lowercase",
                    textDecoration: "underline",
                  }}
                >
                  {rowData?.created_by_mobile || ""}
                  <br />
                  {rowData?.created_by_email || ""}
                </small>
              </p>
            </div>
          </div>

          {isDP && (
            <>
              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">approval status</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.status === "cm_approved"
                      ? "CM Approved"
                      : rowData?.status === "cm_rejected"
                      ? "CM Rejected"
                      : rowData?.status?.replace(/_/g, " ") || "NA"}
                  </p>
                </div>
              </div>

              {/* {!isPending && ( */}
              <>
                <div className="user-details">
                  <div className="user-details-head">
                    <p className="head-name">CM Approval</p>
                  </div>
                  <div className="user-details-info">
                    <p className="info-name">
                      {rowData?.cm_aprv_rej_by_name || "NA"}
                      <br />
                      <small
                        style={{
                          textTransform: "lowercase",
                          textDecoration: "underline",
                        }}
                      >
                        {rowData?.cm_aprv_rej_by_mobile || ""}
                        <br />
                        {rowData?.cm_aprv_rej_by_email || ""}
                      </small>
                    </p>
                  </div>
                </div>

                <div className="user-details">
                  <div className="user-details-head">
                    <p className="head-name">CM Approval Date</p>
                  </div>
                  <div className="user-details-info">
                    <p className="info-name">
                      {formatDateTime(rowData?.cm_aprv_rej_date || "")}
                    </p>
                  </div>
                </div>

                <div className="user-details">
                  <div className="user-details-head">
                    <p className="head-name">CM Approval Remarks</p>
                  </div>
                  <div className="user-details-info">
                    <p className="info-name">
                      {rowData?.cm_aprv_rej_remarks || "NA"}
                    </p>
                  </div>
                </div>

                <div className="user-details">
                  <div className="user-details-head">
                    <p className="head-name">Admin Approval</p>
                  </div>
                  <div className="user-details-info">
                    <p className="info-name">
                      {rowData?.aprv_rej_by_name || "NA"}
                      <br />
                      <small
                        style={{
                          textTransform: "lowercase",
                          textDecoration: "underline",
                        }}
                      >
                        {rowData?.aprv_rej_by_mobile || ""}
                        <br />
                        {rowData?.aprv_rej_by_email || ""}
                      </small>
                    </p>
                  </div>
                </div>
              </>
              {/* )} */}
            </>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">subscription type</p>
            </div>
            <div className="user-details-info">
              <p className="info-name badge">
                {rowData?.is_renewal ? "Renewal" : "Fresh Subscription"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Plan Name</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.plan_name || "NA"} (
                {rowData?.type?.replace(/_/g, " ") || ""})
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Plan Price</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                ₹{convertThenFormat(rowData?.plan_price || 0)}
              </p>
            </div>
          </div>

          {rowData?.is_renewal ? (
            <>
              {/* <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">last subscription</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.last_plan_name?.replace(/_/g, " ") || "NA"}
                  </p>
                </div>
              </div> */}

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">last subscription price</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    ₹{convertThenFormat(rowData?.last_price || 0)} (
                    {rowData?.last_plan_name?.replace(/_/g, " ") || "NA"})
                  </p>
                </div>
              </div>
            </>
          ) : null}

          {isPT && (
            <>
              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">PT sessions</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.n_session || 0} sessions for{" "}
                    {rowData?.duration || 0} days
                  </p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">PT trainer</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{rowData?.trainer_name || "NA"}</p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">slot</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {rowData?.start_time
                      ? convertTo12HourFormat(rowData.start_time)
                      : ""}{" "}
                    -{" "}
                    {rowData?.end_time
                      ? convertTo12HourFormat(rowData.end_time)
                      : ""}
                  </p>
                </div>
              </div>
            </>
          )}

          {!isPT && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">extend days </p>
              </div>
              <div className="user-details-info">
                <p className="info-name icon">
                  {rowData?.extend_days || 0} Days
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">start and expire date</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                {rowData?.start_date
                  ? convertStraight(rowData.start_date)
                  : "-"}{" "}
                TO{" "}
                {rowData?.expire_date
                  ? convertStraight(rowData.expire_date)
                  : "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Payment mode</p>
            </div>
            <div className="user-details-info">
              <p className="info-name icon">
                <b
                  style={{
                    background: "#EB8317",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                  }}
                >
                  {rowData?.payment_mode || "NA"}
                </b>
                {isDual ? (
                  <>
                    (Cash: ₹{convertThenFormat(rowData?.cash_amount || 0)} /
                    Online: ₹{convertThenFormat(rowData?.online_amount || 0)})
                  </>
                ) : null}
              </p>
            </div>
          </div>

          {isPartial && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">first payment mode</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  <b>{rowData?.first_payment_mode || "NA"}</b>{" "}
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Requested BY</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.requested_by_name || "NA"}
                <br />
                <small
                  style={{
                    textTransform: "lowercase",
                    textDecoration: "underline",
                  }}
                >
                  {rowData?.requested_by_mobile || ""}
                  <br />
                  {rowData?.requested_by_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Remarks</p>
            </div>
            <div className="user-details-info">
              <p className="info-name" style={{ textTransform: "initial" }}>
                {rowData?.aprv_rej_remarks || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">User Goal Remarks</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.goal_remarks || "NA"}</p>
            </div>
          </div>
        </div>
      </div>

      {isPartial && rowData?.partial_payment_details?.length > 0 ? (
        <PartialDetails tbData={rowData?.partial_payment_details || []} />
      ) : null}
    </>
  );
};

export default ViewDetails;
